import React from "react";
import BaseTextButton from "../BaseTextButton";
import config from "../../config";
import "./style.scss";
import { useTranslation } from "react-i18next";
import SupportIcon from "../../assets/icons/support.svg";
import LetterIcon from "../../assets/icons/letter.svg";
import InstagramIcon from "../../assets/icons/instagram.svg";
import ROUTES from "../../utils/routes";
import isPayplusDomain from "../../utils/isPayplusDomain";

export default function SectionFooter() {
  const { t, i18n } = useTranslation();
  const suffix = isPayplusDomain() ? "_payplus" : "";

  return (
    <section className="section-footer">
      <div className="blocks">
        <div className="block">
          <div className="author">{t("section_footer.author")}</div>
          <div className="copyright">{t("section_footer.copyright")}</div>
          <div className="contacts">
            <BaseTextButton
              to={ROUTES.SUPPORT_PAGE}
            >
              <img
                loading="lazy"
                src={SupportIcon}
              />
            </BaseTextButton>
            <BaseTextButton
              native={true}
              href={`mailto:${config.spaceIntouchMail}`}
            >
              <img
                loading="lazy"
                src={LetterIcon}
              />
            </BaseTextButton>
            <BaseTextButton>
              <img
                loading="lazy"
                src={InstagramIcon}
              />
            </BaseTextButton>
          </div>
        </div>
        <div className="block">
          {/* "Главное меню" скрыто ТОЛЬКО на wepurplay.ru (isPayplusDomain() === false).
              На in-touch.space и остальных доменах ссылка намеренно показывается — не "чинить". */}
          {isPayplusDomain() && (
            <div>
              <BaseTextButton
                to={ROUTES.LANDING_PAGE}
              >
                {t("section_footer.home")}
              </BaseTextButton>
            </div>
          )}
          <div>
            <BaseTextButton
              to={i18n.language == "ru" ? "/privacy" : "/privacy-payplus"}
            >
              {t("section_footer.privacy_policy")}
            </BaseTextButton>
          </div>
          <div>
            <BaseTextButton
              to={i18n.language == "ru" ? "/conditions" : "/conditions-payplus"}
            >
              {t("section_footer.conditions")}
            </BaseTextButton>
          </div>
        </div>
        <div className="block">
          <div>
            {t(`section_footer.author2${suffix}`)}
          </div>
          <div>
            {t(`section_footer.address${suffix}`)}
          </div>
          <div>
            {t(`section_footer.tel${suffix}`)}
          </div>
          <div>
            <BaseTextButton
              native={true}
              href={`mailto:${config.spaceIntouchMail}`}
            >
              {config.spaceIntouchMail}
            </BaseTextButton>
          </div>
        </div>
      </div>
    </section>
  );
}
